// extracted by mini-css-extract-plugin
export default {"root":"HCF_0ENElo8pKMZLsyOb","pagination":"MGfYoc3ehnucZFXwKCKw","page-size":"G9RzScH5edCd4AgYp4ro","pageSize":"G9RzScH5edCd4AgYp4ro"};